import Field100xImage from "./field100ximage";
import React from 'react';
import {convertSettingsToFilter, isNull, notNull} from "../../../utils/utils";
import {Button, Col, Empty, Progress, Row, Spin, Tooltip, Typography} from "antd";
import {
    CompressOutlined,
    LeftCircleOutlined,
    LoadingOutlined,
    MinusCircleOutlined,
    PlusCircleOutlined,
    RightCircleOutlined,
    ZoomInOutlined,
    ZoomOutOutlined
} from "@ant-design/icons";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import {getZStackUrl} from "../../bloodviewer/utils/fieldUtils";
import {Stack} from "@mui/material";
import {StyledTypography} from "./StyledComponents";
import Annotation from "react-image-annotation";
import {bloodClass, bloodImageProperties} from "../../../utils/const";
import '../../../asset/style/bloodviewer/blood_viewer.css'

const {Text} = Typography;

class Field100xView extends Field100xImage {

    onWheel = (event) =>
        this.state.zoomDisabled && (event.wheelDeltaY > 0 ? this.higherZstack() : this.lowerZstack());

    zoomLevelDisplay = (zoom) => {
        return <Text className={'full-parent flex-center'} style={{color: '#3a4241', fontSize: '24px'}}>
            {(zoom * 500).toFixed(0)} X
        </Text>

    }

    render() {

        let zoomLevel_ = (((this.imageRef || {}).current || {}).state || {}).scale
        if (isNull(zoomLevel_)) {
            zoomLevel_ = this.props.mode === bloodClass.FIELD ? 0.3 : 1;
        }

        if (isNull(this.meta))
            return;

        if (this.props.annotation === '') {
            return <div style={{textAlign: 'center'}}>
                <Empty
                    style={{
                        margin: '2vw',
                        marginTop: '20vh',
                        height: '20vh',
                        width: '42vw'
                    }}
                    image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                    imageStyle={{
                        height: 100,
                    }}
                    description={
                        <span style={{color: 'white'}}>
                            Select an Image to view at 100x
                    </span>
                    }
                >
                </Empty>
            </div>
        }

        let zStackMicrons = (this.state.zStack * this.meta.ZStackStep).toFixed(2);

        let fontSize = 20;
        if (window.innerWidth < 1400) {
            fontSize = 14;
        }

        let boundingHeight = 1080;
        if (notNull(this.fld100xRef.current)) {
            boundingHeight = (this.fld100xRef.current || {}).clientHeight - 40;
        }

        return (
            <div className={'full-parent'} ref={this.fld100xRef}>
                <Row className={'full-parent'} style={{height: '95%', maxHeight: boundingHeight}}>
                    <Row className={'full-parent full-parent-imp'}>
                        <TransformWrapper ref={this.imageRef}
                                          initialScale={this.convertZoomToScale(this.minZoom)}
                                          wheel={{
                                              step: 0.3,
                                              disabled: this.state.zoomDisabled,
                                          }}
                                          limitToBounds={true}
                                          onInit={this.state.image_updated ? this.reposition() : null}
                                          minScale={this.convertZoomToScale(this.minZoom)}
                                          maxScale={this.convertZoomToScale(this.maxZoom)}
                                          onZoomStop={context =>
                                              this.setState({
                                                  zoom: this.convertScaleToZoom(context.state.scale),
                                                  pageRefresh: !this.state.pageRefresh
                                              })}>
                            {({zoomIn, zoomOut, resetTransform, ...rest}) => (
                                <TransformComponent wrapperStyle={{
                                    borderStyle: 'solid', borderWidth: '10px', width: 'calc(100% - 10px)',
                                    height: '100%', borderColor: '#03112c',
                                    backgroundColor: '#03112c'
                                }}>
                                    <Spin indicator={<LoadingOutlined style={{fontSize: 0}} spin/>}
                                          spinning={this.state.loadingImage} wrapperClassName={'full-parent'}>
                                        <div className={'full-parent'}
                                             style={{filter: convertSettingsToFilter(this.props.cssfilter)}}>
                                            <Annotation
                                                handleImageLoaded={() => this.handleImageLoaded()}
                                                src={`${getZStackUrl(this.props.annotation.image, this.state.zStack)}?${new Date()}`}
                                                annotations={this.state.annotations}
                                                disableAnnotation
                                                style={{
                                                    height: bloodImageProperties.HEIGHT,
                                                    width: bloodImageProperties.WIDTH
                                                }}
                                                disableOverlay
                                                disableEditor
                                                disableSelector
                                                allowTouch
                                                renderHighlight={({key, annotation}) => (
                                                    <div
                                                        key={key}
                                                        style={{
                                                            position: 'absolute',
                                                            left: `${annotation.geometry.x}%`,
                                                            top: `${annotation.geometry.y}%`,
                                                            width: `${annotation.geometry.width}%`,
                                                            height: `${annotation.geometry.height}%`,
                                                            border: '5px dashed #7cfc00',
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </Spin>
                                </TransformComponent>
                            )}
                        </TransformWrapper>
                    </Row>
                    <Row className={'full-parent'}
                         style={{position: 'absolute', left: '0', height: '5px', bottom: '7px', zIndex: '200'}}>
                        <Progress strokeWidth={this.state.loadingImage ? "4px" : "0px"}
                                  status={this.state.loadingImage ? "active" : {}}
                                  percent={this.state.loadingImage ? 43 : 100}
                                  className={'full-parent'}
                                  showInfo={false}/>
                    </Row>
                    <Row className={'full-parent'}
                         style={{
                             position: 'absolute',
                             right: '12px',
                             height: '80px',
                             width: '120px',
                             bottom: '7px',
                             zIndex: '200'
                         }}
                    >
                        <Stack direction={"row"} justifyContent={"space-around"} className={"full-width"}>
                            <Tooltip title={'Scroll/pinch to zoom in/out'} placement={'top'}>
                                <StyledTypography
                                    sx={{fontSize: '30px'}}>{this.zoomLevelDisplay(zoomLevel_)}</StyledTypography>
                            </Tooltip>
                        </Stack>
                    </Row>
                </Row>

                <Row className={'full-parent'}
                     style={{height: '5%', minHeight: 40, color: 'white', fontSize: `${fontSize}px`}}>
                    <Col className={'full-height'} span={4}>
                        <Text className={'full-parent flex-center'}
                              style={{color: 'white', fontSize: `${fontSize - 1}px`}}>
                            ZSTACK:
                        </Text>
                    </Col>

                    <Col className={'full-height'} span={8}>

                        <Col className={'full-height flex-center'} span={3}>
                            <Button className={'strip-button-blood'} onClick={this.higherZstack}>
                                <PlusCircleOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
                            </Button>
                        </Col>
                        <Col className={'full-height'} span={16}>
                            <Tooltip title={<p>Use Shift + &#129053; &amp; &#129055; to toggle</p>}>
                                <Text className={'full-parent flex-center'} style={{color: 'white'}}>
                                    {zStackMicrons >= 0 ? "+" + zStackMicrons : zStackMicrons} μ
                                </Text>
                            </Tooltip>
                        </Col>
                        <Col className={'full-height flex-center'} span={3}>
                            <Button className={'strip-button-blood'} onClick={this.lowerZstack}>
                                <MinusCircleOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
                            </Button>
                        </Col>
                    </Col>

                    <Col className={'full-height'} span={12}>
                        <Col className={'full-height'} span={12}>
                            <Col className={'full-height flex-center'} span={8}>
                                <Button className={'strip-button-blood'} onClick={() => this.props.loadPrev(0)}>
                                    <LeftCircleOutlined
                                        style={{color: 'cyan', fontSize: `${fontSize}px`}}></LeftCircleOutlined>
                                </Button>
                            </Col>
                            <Col className={'full-height'} span={8}>
                                <Tooltip title={<p>Use &#129052; &amp; &#129054; to toggle</p>}>
                                    <Text className={'full-parent flex-center'} style={{color: 'white'}}>
                                        #{this.props.annotation.overall_count}
                                    </Text>
                                </Tooltip>
                            </Col>
                            <Col className={'full-height flex-center'} span={8}>
                                <Button className={'strip-button-blood'} onClick={() => this.props.loadNext(0)}>
                                    <RightCircleOutlined
                                        style={{color: 'cyan', fontSize: `${fontSize}px`}}></RightCircleOutlined>
                                </Button>
                            </Col>
                        </Col>
                        <Col className={'full-height'} span={12}>
                            <Col className={'full-height flex-center'} span={8}>
                                <Button className={'strip-button-blood'}
                                        onClick={() => {
                                            this.reposition().then(r => {
                                                this.setState({pageRefresh: !this.state.pageRefresh})
                                            })
                                        }}>
                                    <CompressOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
                                </Button>
                            </Col>
                            <Col className={'full-height flex-center'} span={8}>
                                <Button className={'strip-button-blood'}
                                        onClick={() => {
                                            this.imageRef.current.zoomOut();
                                            setTimeout(() => {
                                                this.setState({pageRefresh: !this.state.pageRefresh})
                                            }, 1000)
                                        }}>
                                    <ZoomOutOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
                                </Button>
                            </Col>
                            <Col className={'full-height flex-center'} span={8}>
                                <Button className={'strip-button-blood'}
                                        onClick={() => {
                                            this.imageRef.current.zoomIn();
                                            setTimeout(() => {
                                                this.setState({pageRefresh: !this.state.pageRefresh})
                                            }, 1000)
                                        }}>
                                    <ZoomInOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
                                </Button>
                            </Col>
                        </Col>
                    </Col>
                </Row>
            </div>
        )

    }

}

export default Field100xView;